export default [
  {
    title: "hhtps://your-news-is-here//",
  },
  {
    title: "hhtps://your-news-is-here//",
  },
  {
    title: "hhtps://your-news-is-here//",
  },
];
